import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "./styles/styles.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThirdwebProvider,useContract, metamaskWallet,coinbaseWallet,walletConnect, } from "@thirdweb-dev/react";

const activeChain = "polygon";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
        <ThirdwebProvider supportedWallets={[metamaskWallet(), coinbaseWallet(), walletConnect()]} activeChain={activeChain}>
      <App />
    </ThirdwebProvider>
   
  </React.StrictMode>
);

